// extracted by mini-css-extract-plugin
export var boxItems = "_7l-1";
export var boxItemsLg = "_7l-2";
export var button = "_7l-7";
export var buttonLg = "_7l-8";
export var filterGroupBox = "_7l-0";
export var icon = "_7l-3";
export var iconSecondary = "_7l-6";
export var iconWrapper = "_7l-4";
export var iconWrapperLg = "_7l-5";